import { render, staticRenderFns } from "./top1.vue?vue&type=template&id=589dd2e4&"
import script from "./top1.vue?vue&type=script&lang=js&"
export * from "./top1.vue?vue&type=script&lang=js&"
import style0 from "./top1.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports